import history from "../../../../Utils/history";

export function isReferrer(location) {
  if (location?.state && location?.state?.referrer !== "/login") {
    history.push(location.state.referrer);
  } else {
    history.push("/");
  }
}
